import React__default, { forwardRef, useState } from 'react';
import styled from 'styled-components';
import sx from '../../sx.js';
import { themeGet } from '../../utils/theme-get.js';
import Box from '../Box/Box.js';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';
import AtlasCheckbox from '../AtlasCheckbox/AtlasCheckbox.js';

/* eslint-disable @typescript-eslint/no-unnecessary-condition */
const Wrapper = styled(Box).withConfig({
  displayName: "RuleFilter__Wrapper",
  componentId: "sc-ebxkso-0"
})(["display:grid;background-color:", ";border-radius:", ";padding-inline-start:", ";padding-inline-end:", ";padding-block-start:", ";grid-template-areas:'checkbox tag';grid-template-columns:auto max-content;grid-template-rows:", ";column-gap:", ";align-items:center;text-align:left;", ""], themeGet('colors.elevation.surface.default.[default]'), themeGet('radii.2'), themeGet('space.3'), themeGet('space.3'), themeGet('space.2'), themeGet('space.4'), themeGet('space.4'), sx);
const TagWrapper = styled(Box).withConfig({
  displayName: "RuleFilter__TagWrapper",
  componentId: "sc-ebxkso-1"
})(["grid-area:'tag';grid-row:1 / 1;", ""], sx);
const CheckboxWrapper = styled(Box).withConfig({
  displayName: "RuleFilter__CheckboxWrapper",
  componentId: "sc-ebxkso-2"
})(["grid-area:'checkbox';display:flex;grid-row:1 / 1;", ""], sx);
const RuleFilter = /*#__PURE__*/forwardRef(({
  children,
  ruleFilterLabel,
  ruleFilterValue,
  trailingVisual: TrailingVisual,
  labelSize = 'default',
  defaultChecked = false,
  id,
  isChecked,
  onChange,
  ...props
}, forwardedRef) => {
  const innerRef = React__default.useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  const hasTrailingVisual = Boolean(TrailingVisual);
  const [internalCheck, setInternalCheck] = useState(isChecked !== null && isChecked !== void 0 ? isChecked : defaultChecked);
  const onChangeCallback = React__default.useCallback(event => {
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
    setInternalCheck(event.currentTarget.checked);
  }, [onChange]);
  return /*#__PURE__*/React__default.createElement(Wrapper, props, /*#__PURE__*/React__default.createElement(CheckboxWrapper, null, /*#__PURE__*/React__default.createElement(AtlasCheckbox, {
    defaultChecked: defaultChecked,
    isChecked: isChecked,
    labelSize: labelSize,
    label: ruleFilterLabel,
    value: ruleFilterValue,
    onChange: onChangeCallback,
    id: id,
    ref: innerRef
  }), hasTrailingVisual ? /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      color: 'icon.subtle'
    }
  }, typeof TrailingVisual === 'function' ? /*#__PURE__*/React__default.createElement(TrailingVisual, null) : TrailingVisual) : null), React__default.Children.map(React__default.Children.toArray(children), (child, idx) => {
    if (!child) {
      return null;
    }
    return /*#__PURE__*/React__default.createElement(TagWrapper, null, /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: idx
    }, (isChecked !== null && isChecked !== void 0 ? isChecked : internalCheck) ? /*#__PURE__*/React__default.cloneElement(child, {
      isChecked
    }) : null));
  }));
});
RuleFilter.displayName = 'RuleFilter';

export { RuleFilter };
